import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/reducers/rootReducer';
import { first, last } from 'lodash';

const notificationStreamConfigSelector = (state: RootState) =>
  state.notification.notificationStreamConfig;

const isHeaderNotificationsVisibleSelector = (state: RootState) =>
  state.notification.isHeaderNotificationsVisible;

const notificationsSelector = (state: RootState) =>
  state.notification.notifications;

const firstNotificationIdSelector = createSelector(
  notificationsSelector,
  (notifications): number | undefined => first(notifications)?.notificationId,
);

const lastNotificationIdSelector = createSelector(
  notificationsSelector,
  (notifications): number | undefined => last(notifications)?.notificationId,
);

const isInitialDataLoadedSelector = (state: RootState) =>
  state.notification.isInitialDataLoaded;

const unreadNotificationsCountSelector = (state: RootState): number =>
  state.notification.notificationInfo?.unreadCount || 0;

const hasMoreSelector = (state: RootState) => state.notification.hasMore;

const recipientsSelector = (state: RootState) => state.notification.recipients;
const isRecipientsLoadingSelector = (state: RootState) => state.notification.isRecipientsLoading;

const approvedEntitiesDelayedNotificationIdsSelector = (state: RootState) =>
  state.notification.approvedEntitiesDelayedNotificationIds;

const isApprovedEntityInstantNotificationReadSelector = (
  notificationId: number,
) => (state: RootState) =>
  !state.notification.approvedEntitiesInstantNotificationIds.includes(
    notificationId,
  );

const approvedEntitiesNotificationIdsSelector = (state: RootState) => [
  ...state.notification.approvedEntitiesInstantNotificationIds,
  ...state.notification.approvedEntitiesDelayedNotificationIds,
];

export {
  hasMoreSelector,
  recipientsSelector,
  notificationsSelector,
  lastNotificationIdSelector,
  isInitialDataLoadedSelector,
  firstNotificationIdSelector,
  notificationStreamConfigSelector,
  unreadNotificationsCountSelector,
  isHeaderNotificationsVisibleSelector,
  approvedEntitiesNotificationIdsSelector,
  approvedEntitiesDelayedNotificationIdsSelector,
  isApprovedEntityInstantNotificationReadSelector,
  isRecipientsLoadingSelector,
};
